import { EField, IExtraData } from "./schema.shareDocumentMessage.types";

export const getInitialValues = (extraData: IExtraData) => {
  const { customMessageBody } = extraData;
  return {
    [EField.CustomMessageBody]: customMessageBody,
  };
};
